import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import GrassOutlinedIcon from "@mui/icons-material/GrassOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { setDrawingMode, clearAreaDrawing } from "../reducers/MapSlice";
import ProjectTokenDialog from "./ProjectTokenDialog";

export default function AddMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [tokenDialogOpen, setTokenDialogOpen] = useState(false);

  const startDrawing = (mode) => {
    dispatch(clearAreaDrawing());
    dispatch(setDrawingMode(mode));
    setAnchorEl(null);
  };

  const handleAddProjectClick = () => {
    setAnchorEl(null);
    setTokenDialogOpen(true);
  };

  const handleTokenSuccess = (token) => {
    setTokenDialogOpen(false);
    navigate("/add-project", { state: { projectToken: token } });
  };

  return (
    <>
      <Tooltip title={t("map.add")}>
        <IconButton
          aria-label={t("map.add")}
          aria-haspopup="menu"
          aria-expanded={Boolean(anchorEl)}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{
            color: "primary.main",
            border: "2px solid",
            borderRadius: "12px",
            p: "7px",
          }}
        >
          <AddOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
              mt: 1,
              minWidth: 200,
            },
          },
        }}
      >
        <MenuItem onClick={() => startDrawing("owner")} sx={{ fontSize: 14 }}>
          <ListItemIcon>
            <PersonOutlinedIcon fontSize="small" />
          </ListItemIcon>
          {t("map.addOwner")}
        </MenuItem>
        <MenuItem onClick={() => startDrawing("field")} sx={{ fontSize: 14 }}>
          <ListItemIcon>
            <GrassOutlinedIcon fontSize="small" />
          </ListItemIcon>
          {t("map.addField")}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleAddProjectClick} sx={{ fontSize: 14 }}>
          <ListItemIcon>
            <MapOutlinedIcon fontSize="small" />
          </ListItemIcon>
          {t("map.addProject")}
        </MenuItem>
      </Menu>
      <ProjectTokenDialog
        open={tokenDialogOpen}
        onClose={() => setTokenDialogOpen(false)}
        onSuccess={handleTokenSuccess}
      />
    </>
  );
}
